(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warlord-home"] && !Shopify.designMode) return;
  try {
    
  const initializeArchive = () => document.querySelectorAll('.wk-home').forEach((section) => {
    const carousel = section.querySelector('[data-wk-carousel]');
    if (!carousel || carousel.dataset.wkReady === 'true') return;
    carousel.dataset.wkReady = 'true';
    const step = () => (carousel.querySelector('.wk-product')?.getBoundingClientRect().width || carousel.clientWidth) + parseFloat(getComputedStyle(carousel).gap || '0');
    section.querySelector('[data-wk-carousel-previous]')?.addEventListener('click', () => carousel.scrollBy({ left: -step(), behavior: 'smooth' }));
    section.querySelector('[data-wk-carousel-next]')?.addEventListener('click', () => carousel.scrollBy({ left: step(), behavior: 'smooth' }));
    const featured = section.querySelector('[data-wk-featured]');
    const featuredImage = featured?.querySelector('.wk-home__featured-image');
    const featuredTitle = featured?.querySelector('[data-wk-featured-title]');
    const featuredPrice = featured?.querySelector('[data-wk-featured-price]');
    const featuredLink = featured?.querySelector('[data-wk-featured-link]');
    section.querySelectorAll('[data-wk-product-switch]').forEach((item) => {
      item.addEventListener('click', (event) => {
        const image = item.dataset.image;
        if (!image || !featuredImage) return;
        event.preventDefault();
        featuredImage.src = image;
        featuredImage.removeAttribute('srcset');
        if (featuredTitle) featuredTitle.textContent = item.dataset.title || '';
        if (featuredPrice) featuredPrice.textContent = item.dataset.price || '';
        if (featuredLink && item.dataset.url) featuredLink.href = item.dataset.url;
        section.querySelectorAll('[data-wk-product-switch]').forEach((entry) => entry.classList.toggle('is-active', entry === item));
        featured?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    section.querySelector('[data-wk-product-switch]')?.classList.add('is-active');
  });
  initializeArchive();
  document.addEventListener('shopify:section:load', initializeArchive);

  } catch(e) { console.error(e); }
})();
})();
